<template>
  <div class="page-container" id="page-container">
    <div class="page-title padding pb-0 ">
      <h2 class="text-md mb-0">Verlage</h2>
    </div>
    <div class="padding">
      <div class="row">
        <div class="col-md-12">


          <div v-if="!publishersLoaded" class="h-100 d-flex justify-content-center align-items-center">
            <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
          </div>

          <div v-else class="card card-form">
            <div class="card-body">
              <div class="form-section-header">Neuer Verlage</div>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">Name <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                      :class="errors.first('publisher.name')?'is-invalid':''"
                      v-model="publisher.name"
                      v-validate="'required'"
                      data-vv-name="name"
                      type="text"
                      placeholder="Verlage"
                      ref="nameField"
                      :state="errors.first('name') ? false : null">
                  ></b-form-input>
                  <div v-if="errors.first('name')" class="text-danger">Den Namen bitte eingeben</div>
                </b-col>
              </b-row>

              <div class="form-buttons">
                <button type="submit" class="btn btn-link" @click="$router.go(-1)">{{ $t('message.cancel') }} </button>
                <button type="submit" class="btn btn-success" @click="proceed">{{ $t('message.proceed') }} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
  import { PUBLISHER_REQUEST, PUBLISHER_SAVE, PUBLISHER_GET_NEW_ID } from '@/store/actions/publishers';

  export default {
    name: "CreatePublisher",

    data() {
      return {
        editor: ClassicEditor,
        editorConfig: {
          // The configuration of the editor.
        },

        publisher: {
          name: null
        },
      }
    },

    mounted() {
      if (this.$route.params.id == undefined) {
        this.$store.dispatch(PUBLISHER_GET_NEW_ID).then(newId => {
          console.log(newId)
          this.publisher.id = newId
        })
      } else {
        this.getPublisher(this.$route.params.id);
      }
    },

    methods: {
      proceed() {
        this.$validator.validateAll().then(result => {
          if (!result) {
            this.$swal({
              title: 'Error!',
              text: this.$t("message.fillRequiredFields"),
              type: 'error',
              confirmButtonText: 'OK'
            });

            this.showValidateErrors = true;
          } else {
            if (this.publisher.id == undefined) {
              return this.savePublisher();
            }

            return this.updatePublisher();
          }
        });
      },

      async savePublisher() {
        await this.$store.dispatch(PUBLISHER_SAVE, this.publisher)
          .then((response) => {
            this.$swal({
              title: this.$t("message.success"),
              text: this.$t("message.successfullyAdded"),
              type: 'success',
              confirmButtonText: 'OK'
            });

            this.$router.push({ name: 'PublisherList' })
          })
          .catch(error => {
            console.log(`error ${error}`)
          })
      },

      async updatePublisher() {
        await this.$store.dispatch(PUBLISHER_SAVE, this.publisher)
          .then((response) => {
            this.$swal({
              title: this.$t("message.success"),
              text: this.$t("message.successfullyUpdated"),
              type: 'success',
              confirmButtonText: 'OK'
            });

            this.$router.push({ name: 'PublisherList' })
          }).catch(error => {
            console.log(`error ${error}`)
          });
      },

      async getPublisher(id) {
        if (id != undefined) {
          this.$store.dispatch(PUBLISHER_REQUEST_BY_ID, id).then(publisher => {
            this.publisher = publisher;
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
  }
</script>


<style scoped>

</style>